import Styles from '@/assets/js/Styles';
import Container from '@/components/Container';
import React, { useState } from 'react';
import { Button, Snackbar, Alert, Typography } from '@mui/material';
import { Api } from '@/services/Api';

export const PrepareTestData = () => {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success',
  });

  const onClickPrepareTestData = async () => {
    setLoading(true);
    try {
      Api.convertProdToTestData();
      setSnackbar({ open: true, message: 'Test data prepared successfully.', severity: 'success' });
    } catch (error) {
      setSnackbar({ open: true, message: 'Error preparing test data.', severity: 'error' });
      console.error('Error preparing test data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      column
      fullWidth
      sx={{
        p: 4,
        border: `1px solid ${Styles.Colors.MEDIUM_LIGHT_GREY}`,
        borderRadius: Styles.Dimensions.RADIUS_ROUNDNESS_DEFAULT,
      }}>
      <Container left fullWidth>
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>Forbered testdata</Typography>
      </Container>
      <Container left fullWidth sx={{ marginTop: 2 }}>
        <Typography>
          Denne funksjonen vil vaske databasen og oppdatere domenene i ditt nåværende miljø. Hele denne prosessen kan ta
          inntil 2 timer.
        </Typography>
      </Container>
      <Container>
        <Button
          onClick={onClickPrepareTestData}
          color='primary'
          variant='contained'
          sx={{ marginTop: 2 }}
          disabled={loading}>
          Sett i gang
        </Button>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}>
          <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </Container>
  );
};
